<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[billing$]" [loading]="IsLoading"></ef-loading-container>
<ef-defer-billing-presenter
  [billing] = 'billing$ | async'
  [tasks] = 'tasks$ | async'
  [contracts] = 'contracts$ | async'
  [chargenumbers] = 'chargenumbers$ | async'
  [txntypes] = 'txntypes$ | async'
  [userGroups] = 'userGroups$ | async'
  [directreports] = 'directreports$ | async'
  [serviceitems] = 'serviceitems$ | async'
  [payrollitems] = 'payrollitems$ | async'

  [process] = 'process$ | async'
  [userInfo] = 'userInfo$ | async'
  [IsLoading]="IsLoading"
  (LoadChargeNumbers)="onLoadChargeNumbers($event)"
  (SaveBilling)="onSaveBilling($event)"
  (LoadBilling)="onLoadBilling($event)"
  (DeleteBilling)="onDeleteBilling($event)"
  [selectedError]="selectedErrorWithStatus$ | async"
  (ShowError)="this.ShowError.next($event)">

</ef-defer-billing-presenter>
<!-- [seitems] = 'items$ | async' -->
